import { Box, Grid, Stack, DialogContent } from '@mui/material';
import { useState, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { IWorkspace, getWorkspaceById, generateWorkSpaceAPIKeys } from 'wisestep-api';
import {
  ControlledTextInput,
  WsButton,
  WsTitleBanner,
  Label,
  WsSelect,
  WsInputNumber,
  WsRadioGroup,
  WsDialog,
} from 'wisestep-base';

import {
  autoJoinOptions,
  LayoutTheme,
  mailProviderList,
  parserServiceList,
  StyledTextareaAutosize,
  visibilityOptions,
  // multiLoginOptions,
} from '../helper/workspaceListingHelper';

import ApiKeysModal from './ApiKeysModal';
import ConfigureMonsterAccountDrawer from './ConfigureMonsterAccountDrawer';

const WorkspaceDetails = () => {
  const navigate = useNavigate();
  const formOptions = {
    defaultValues: { parserService: 'wisestepParser', accountName: '' },
  };
  const methods = useForm(formOptions);
  const { reset, setValue } = methods;
  const params = useParams();
  const workspaceId: string = params.workspaceId ?? '';
  const [open, setOpen] = useState(false);
  const [openRegnDrawer, setOpenRegnDrawer] = useState<boolean>(false);
  const [openAPIModal, setOpenAPIModal] = useState<boolean>(false);
  const [workspace, setWorkspace] = useState<IWorkspace | null>(null);
  const handleDrawerOpen = () => {
    setValue('accountName', '');
    setOpen(true);
  };

  const handleDrawerClose = () => {
    reset();
    setOpen(false);
  };

  useEffect(() => {
    const setWorkspaceById = async () => {
      const response = await getWorkspaceById(workspaceId);
      setWorkspace(response.data);
    };
    setWorkspaceById();
  }, [workspaceId]);

  const generateApiKeys = async (event) => {
    event.preventDefault();
    const data = await generateWorkSpaceAPIKeys(workspaceId);
    const updatedWorkSpace = workspace;
    if (updatedWorkSpace) updatedWorkSpace['keysGenerated'] = data.data.keysGenerated;
    setWorkspace({
      ...updatedWorkSpace,
      name: updatedWorkSpace?.name ?? '',
      ownerId: updatedWorkSpace?.ownerId ?? '',
      workspaceUser: updatedWorkSpace?.workspaceUser ?? { id: '', workspaceId: '', userId: '' },
    });
    setOpenRegnDrawer(false);
  };

  return (
    <LayoutTheme>
      <FormProvider {...methods}>
        <WsTitleBanner
          title="Workspace Administration"
          goBack={() => navigate('/workspace/listing')}
        />
        <br></br>
        <Box p={2} bgcolor="white">
          <Grid container item xs={12} display="flex" pt={2} spacing={3}>
            <Grid item xs={6}>
              <ControlledTextInput
                name="title"
                labelText="Name of Organisation*"
                type="text"
                fullWidth
                placeholder="Eg, Java Developer"
                variant="outlined"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="workspaceLink"
                labelText="Workspace Link*"
                type="text"
                fullWidth
                placeholder="https: //ankulmoney.wisestep.com"
                variant="outlined"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextInput
                name="tags"
                labelText="Tags"
                type="text"
                fullWidth
                placeholder="Add a tag"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="address"
                labelText="Address"
                type="text"
                fullWidth
                placeholder=""
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="location"
                labelText="Location"
                type="text"
                fullWidth
                placeholder="Enter a location"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="compWebsite"
                labelText="Company website or linkedIn or other social URL"
                type="text"
                fullWidth
                placeholder="Company URL"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="linkedDomains"
                labelText="Linked Domains"
                type="text"
                fullWidth
                placeholder="Add a tag"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={6} p={1.5}>
              <Label>About</Label>
              <StyledTextareaAutosize name="about" minRows={2} />
            </Grid>
            <Grid item xs={6}>
              <ControlledTextInput
                name="owner"
                labelText="Owner"
                type="text"
                fullWidth
                placeholder="ankul.kumar@edoorsinc.com"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <ControlledTextInput
                name="compWebsite"
                labelText="Alternate Email"
                type="text"
                fullWidth
                placeholder="Enter your free gmail yahoo webmail account"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <ControlledTextInput
                name="phoneNumber"
                labelText="Phone Number"
                type="number"
                fullWidth
                placeholder="Phone Number"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <ControlledTextInput
                name="linkedinProfileLink"
                labelText="Linkedin Profile Link"
                type="text"
                fullWidth
                placeholder="Linkedin Profile Link"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>Visibility</Label>
              <WsRadioGroup name="visibility" selectArray={visibilityOptions} />
            </Grid>
            <Grid item xs={3}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>Auto Join</Label>
              <WsRadioGroup name="autoJoin" selectArray={autoJoinOptions} />
            </Grid>
            {/* <Grid item xs={12}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                Allow Multi login To Job Board
              </Label>
              <Grid item xs={4}>
                <Stack direction="row">
                  <WsRadioGroup name="multiLogin" selectArray={multiLoginOptions} row={true} />
                  <WsButton>Delete Existing Sessions</WsButton>
                </Stack>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                Max Sessions per Job Board
              </Label>
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="careerBuilder" label="Career Builder" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="cwJobs" label="CW Jobs" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="dice" label="Dice" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="jobServe" label="Job Serve" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="linkedRecruiter" label="Linked Recruiter" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="monsterUK" label="Monster UK" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="monsterUS" label="Monster US" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="naukri" label="Naukri" variant="outlined" />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="techfetch" label="Techfetch" variant="outlined" />
            </Grid>*/}
            <Grid item xs={12}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>Mass Mailing Settings</Label>
            </Grid>
            <Grid item xs={3}>
              <WsInputNumber
                name="mailsPerDay"
                label="Mails/Day to Invited Vendor"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2} pb={2}>
              <WsSelect
                name="salaryCurrency"
                label="Mail Provider"
                selectArray={mailProviderList}
                variant="outlined"
                defaultValue="Select"
              />
            </Grid>
            <Grid item xs={12}>
              <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>Parser Service</Label>
            </Grid>
            <Grid item xs={2} pb={2}>
              <WsSelect
                name="parserService"
                label="Select"
                selectArray={parserServiceList}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <WsButton onClick={() => handleDrawerOpen()}>Configure Monster Account</WsButton>
          <Grid container spacing={1} mt={1}>
            {!workspace?.keysGenerated ? (
              <Grid item>
                <WsButton onClick={generateApiKeys}>Generate Api Keys</WsButton>
              </Grid>
            ) : (
              <>
                <Grid item xs={1.2}>
                  <WsButton onClick={() => setOpenAPIModal(true)}>view Api Keys</WsButton>
                </Grid>
                <Grid item xs={1.6}>
                  <WsButton onClick={() => setOpenRegnDrawer(true)}>Re Generate Api Keys</WsButton>
                </Grid>
              </>
            )}
          </Grid>
          <Stack
            direction="column"
            spacing={1}
            justifyContent="flex-start"
            alignItems="start"
            pt={2}
          >
            <Label sx={{ fontSize: '16px', fontWeight: 'bold' }}>Notes</Label>
            <WsButton variant="text" size="small">
              Add a note
            </WsButton>
          </Stack>
          <WsButton>Update Workspace</WsButton>
          <ConfigureMonsterAccountDrawer
            openDrawer={open}
            workspace={workspace}
            onClose={() => handleDrawerClose()}
          />
          {openAPIModal && (
            <ApiKeysModal
              openDrawer={openAPIModal}
              onClose={() => setOpenAPIModal(false)}
              workspaceId={workspaceId}
            />
          )}
          <WsDialog openDialog={openRegnDrawer} size="small">
            <DialogContent>
              <Grid alignItems="center" container spacing={1} direction="column">
                <Grid item xs={12}>
                  <Label sx={{ fontWeight: 'bold' }}>
                    Are you sure you want to Re generate API keys?
                  </Label>
                </Grid>
                <Grid
                  item
                  width="40%"
                  display="flex"
                  justifyContent="space-between"
                  alignSelf="center"
                >
                  <WsButton onClick={generateApiKeys}>Yes</WsButton>
                  <WsButton onClick={() => setOpenRegnDrawer(false)}>No</WsButton>
                </Grid>
              </Grid>
            </DialogContent>
          </WsDialog>
        </Box>
      </FormProvider>
    </LayoutTheme>
  );
};

export default WorkspaceDetails;
